import { DEFAULT_LANGUAGE } from '~shared/i18n/languages';

export interface ResolveLanguageInput {
  /** Явный выбор участника, запомненный в браузере. */
  stored: string | null;
  /** `navigator.languages`: первый — предпочитаемый. */
  browserLanguages: readonly string[];
  /** Коды языков проекта. */
  supported: readonly string[];
}

/**
 * Язык интерфейса: запомненный выбор → предпочитаемый язык браузера → русский.
 * AICODE-NOTE: смотрим только первый язык браузера, а не весь список — так задал заказчик
 * (`en`, `kk` → русский). Перебор списка — смена одной строки.
 */
export function resolveLanguage({ stored, browserLanguages, supported }: ResolveLanguageInput): string {
  if (stored && supported.includes(stored)) return stored;
  const preferred = browserLanguages[0]?.toLowerCase();
  if (preferred) {
    if (supported.includes(preferred)) return preferred;
    const primary = preferred.split('-')[0];
    if (supported.includes(primary)) return primary;
  }
  return DEFAULT_LANGUAGE;
}
